export const FocusDirective = {
  /**
   * @param {HTMLElement} el
   */
  inserted: function (el) {
    setTimeout(() => el.focus(), 500);
  }
};
